import { Component, inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { version, buildNumber, buildDate } from '../../../../../package.json';
import { EnvironmentStore } from '../../environment/environment.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'rb-footer',
  imports: [DatePipe, TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  host: { class: 'footer' },
})
export class FooterComponent implements OnInit {
  date = new Date();
  packageVersion = version;
  packageBuildNumber = buildNumber;
  packageBuildDate = buildDate;
  readonly store = inject(EnvironmentStore);

  ngOnInit(): void {
    if (!this.store.info()) {
      this.store.getEnvironment();
    }
  }
}
